module.exports = __webpack_public_path__ + "static/media/burn.185d675b.svg";